import { motion } from 'framer-motion';

// Thin gold scanline that sweeps down the mobile menu panel once on open,
// paired with a quick flicker, giving a subtle "digital boot-up" feel.
// The parent container must be `relative overflow-hidden`.
export const MenuScanline = () => (
  <>
    <motion.div
      className="pointer-events-none absolute inset-x-0 top-0 z-10 h-12"
      style={{
        background:
          'linear-gradient(180deg, hsl(var(--lxra-gold) / 0.6) 0%, hsl(var(--lxra-gold) / 0.1) 65%, transparent 100%)',
      }}
      initial={{ top: '-12%', opacity: 0 }}
      animate={{ top: '100%', opacity: [0, 1, 1, 0] }}
      transition={{ duration: 0.85, ease: [0.16, 1, 0.3, 1], times: [0, 0.12, 0.8, 1] }}
      data-testid="menu-scanline"
    />
    <motion.div
      className="pointer-events-none absolute inset-0 z-0 bg-[hsl(var(--lxra-gold))]"
      initial={{ opacity: 0.06 }}
      animate={{ opacity: 0 }}
      transition={{ duration: 0.35, ease: 'easeOut' }}
    />
  </>
);
